define('Search/SearchResults',[
    "jquery",
    "eventManager",
    "Search/Search",
    "instantsearch",
    "text!LNRS/Search/Templates/SearchResultsItem.html"
], function ($, eventManager, Search, instantsearch, itemTemplate) {

    function SearchResults(scope, searchResultsId, hitsPerPage, noResultsLabel, searchStatisticsId, numberOfResultsPluralLabel, numberOfResultsSingularLabel, downloadItemTemplateId, newsTemplateId) {
        Search.addWidget(
            instantsearch.widgets.hits({
                container: '#' + searchResultsId,
                templates: {
                    empty: "<div class='no-results'>" + noResultsLabel + "</div>",
                    item: itemTemplate
                },
                transformData: {
                    item: function (hit) {
                        // "<link linktype="external" url="http://www.cardrates.com/news/lexisnexis-risk-solutions-improves-small-business-lending/" />"
                        hit["url"] = hit["_template"] === downloadItemTemplateId ? hit["link to pdf"]
                            : hit["_template"] === newsTemplateId ? hit["_news_link"]
                            : hit["url"];
                        hit["openInNew"] = hit["_template"] === newsTemplateId || hit["_template"] === downloadItemTemplateId;

                        if (hit["url"]) {
                            hit["url-label"] = hit["url"].replace('//', "\/\/");
                        }
                        
                        return hit;
                    }
                },
                hitsPerPage: hitsPerPage
            })
        );

        var oneItemText = numberOfResultsSingularLabel.replace("#", "{{nbHits}}");
        var manyItemsText = numberOfResultsPluralLabel.replace("#", "{{nbHits}}");

        Search.addWidget(
            instantsearch.widgets.stats({
                container: '#' + searchStatisticsId,
                templates: {
                    body: '{{#query}}{{#hasNoResults}}' + noResultsLabel + ' "{{query}}"{{/hasNoResults}}{{#hasOneResult}}' + oneItemText + ' "{{query}}"{{/hasOneResult}}{{#hasManyResults}}' + manyItemsText + ' "{{query}}"{{/hasManyResults}}{{/query}}'
                }
            })
        );

        $(scope).on("click", ".ais-hits--item", function (ev) {
            var searchProvider = Search.search, el = ev.currentTarget;
            eventManager.trigger("Search-Result-selected", searchProvider, el);
        });
    }

    return function InitSearchResults(args) {
        return args.IsExperienceEditorEditing ? null : new SearchResults(
            args.scope,
            args.SearchResultsId,
            args.HitsPerPage,
            args.NoResultsLabel,
            args.SearchStatisticsId,
            args.NumberOfResultsPluralLabel,
            args.NumberOfResultsSingularLabel,
            args.DownloadItemTemplateId,
            args.InTheNewsTemplateId);
    }
});
